<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="TokPaymentError">

  </section>
</template>
<script lang="js">
export default {
  name: 'paymentError',
  props: ['item'],
  data() {
    return {};
  },
  beforeMount() {
    window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Cancelled', this.item);
    this.$router.push('/home');
  },
  mounted() {
  },
  methods: {},
  computed: {},
  components: {},
};
</script>
<style lang="scss" scoped>

</style>
